import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/pc/');

gsap.registerPlugin(ScrollTrigger);

export default function Comp() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const [isShowDesc, setIsShowDesc] = useState(false);
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    const imgMap: any = {
        us: ['animE.webp', 'animE.jpg'],
        au: ['animE_au.webp', 'animE_au.png'],
    };

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.animationE`,
            offset: -0.5 * layoutH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '0%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setIsShowDesc(true);
        });

        sceneA1.on('leave', function () {
            setIsShowDesc(false);
        });
        // @ts-ignore
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationE} animationE GtmModuleData-section`} data-section-id={css.animationE} data-section-title={t('delta2.aniE_msg1')}>
            <div className="sticky-box">
                <div className="img-box">
                    <EFPic name={imgMap[locale] || imgMap.us} alt={t('delta2.aniE_msg1')} />
                </div>
                <div className={`${isShowDesc ? 'show-mask' : ''} mask`}></div>
                <div className={`${isShowDesc ? 'show-desc' : ''} msg-box`}>
                    <div className="msg-title1">{t('delta2.aniE_msg1')}</div>
                    <div className="msg-title2 title-bolder">{t('delta2.aniE_msg2')}</div>
                </div>
            </div>
        </div>
    );
}
